const level = [
  [ 99,  99,  99,   0,   0,   0,   0,   0,   0,   0],
  [ 99,  38,  99,  99,  99,  99,  99,   0,   0,   0],
  [ 99,  64,  77,   0,   0,   0,  99,   0,   0,   0],
  [ 99,   0,   9,  10,   7,  52,  99,   0,   0,   0],
  [ 99,   0,   0,   0,   0,  99,  99,   0,   0,   0],
  [ 99,  99,  99,  99,  99,  99,   0,   0,   0,   0],
  [  0,   0,   0,   0,   0,   0,   0,   0,   0,   0],
  [  0,   0,   0,   0,   0,   0,   0,   0,   0,   0],

]

export default level